module.exports = __webpack_public_path__ + "img/1592833888.3cf6cb95.jpg";